var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1536 4.45368C30.5644 -1.62017 50.5063 -0.0736033 56.5802 9.33719C62.6541 18.748 60.2492 45.7833 50.8384 51.8572C41.4276 57.931 7.53982 50.6143 1.46597 41.2035C-4.60788 31.7927 11.7428 10.5275 21.1536 4.45368Z",
    fill: "#F2BC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBg);
export default __webpack_public_path__ + "static/media/icon-bg.44e906a5837cc1923118d1e901f76ac3.svg";
export { ForwardRef as ReactComponent };